import React from 'react'
import { ResponsiveRowProps } from './responsiveRow.props'

export const ResponsiveRow = ({
  children,
  mobileCols,
  desktopCols,
  tabletCols,
}: ResponsiveRowProps) => {
  const isArray = Array.isArray(children)

  return (
    <section
      className={`row g-4 row-cols-1 row-cols-${mobileCols} row-cols-md-${tabletCols} row-cols-lg-${desktopCols}`}
    >
      {isArray ? (
        children.map((child: any, index: number) => (
          <div key={`RowChild__${index}`}>{child}</div>
        ))
      ) : (
        <div>{children}</div>
      )}
    </section>
  )
}
